export default __webpack_public_path__ + "static/media/second.4d805c90.svg";